// Leaflet sucht seine Standard-Marker-Icons relativ zum Bundle und findet sie dort
// nicht. Dieser Import-Nebeneffekt biegt die Pfade auf ein CDN um.
//
// Liegt bewusst in einem eigenen Modul: So bleibt MapView frei von Seiteneffekten
// und der Barrel-Export des Karten-Moduls tree-shakebar.
import L from "leaflet";

delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});
